import CustomerLife from '@app/pages/customers/Partials/customer-life/CustomerLife';

export default CustomerLife;
